import {ReactComponent as WhatsAppIcon} from './whatsApp.svg'

function WhatsApp() {
  return <WhatsAppIcon />
}

export default WhatsApp
